/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable eqeqeq */
/* eslint-disable-next-line max-len */
import { PriorAuthorizationDomain,
  PriorAuthorizationDomainDetails,
  ProcedureDetailDomain } from '../interfaces/PriorAuthorizationDomain';
import { PriorAuthorizationBaseDto } from '../interfaces/PriorAuthorizationBaseDto';
import dataObfuscator from '../services/Obfuscator/dataObfuscator.service';
import { appInsights } from '../AppInsights';

const ToDomainObject = (priorAuthDto: PriorAuthorizationBaseDto) => {
  const authDetailsList: PriorAuthorizationDomainDetails[] = [];
  priorAuthDto.priorAuthorizationBody.forEach((serviceDetail, index) => {
    const procDomainList: ProcedureDetailDomain[] = [];
    serviceDetail.procedures.forEach((proc, index) => {
      const procDomain: ProcedureDetailDomain = {
        cptCode: proc.cptCode,
        processedBy: proc.processedBy,
        procedureCode: proc.cptCode,
        procedureStartDate: proc.procedureStartDate ? proc.procedureStartDate : '',
        unitType: proc.unitType ? proc.unitType : '',
        unitFrequency: proc.unitFrequency ? proc.unitFrequency.toString() : '',
        modifier: proc.modifier1 ? proc.modifier1 : '',
        modifier2: proc.modifier2 ? proc.modifier2 : '',
        lob: proc.lob,
        NDCCode: proc.medication == null ? '' : proc.medication.ndccode,
        drugName: proc.medication == null ? '' : proc.medication.name,
        doseQty: proc.medication == null ? null : Number(proc.medication.dosageinformation?.doseqty),
        doseQtyUnit: proc.medication == null ? '' : proc.medication.dosageinformation == null ? '' : proc.medication.dosageinformation.doseqtyunit,
        adjustedDrugDosage: proc.medication == null ? '' : proc.medication.dosageinformation == null ? '' : proc.medication.dosageinformation.adjustedcode,
        route: proc.medication == null ? '' : proc.medication.dosageinformation == null ? '' : proc.medication.dosageinformation.route,
        frequency: proc.medication == null ? '' : proc.medication.dosageinformation == null ? '' : proc.medication.dosageinformation.frequency,
      };
      procDomainList.push(procDomain);
    });

    authDetailsList.push({
      procedureCode: serviceDetail.procedureCode,
      levelOfUrgency: serviceDetail.levelOfUrgency,
      levelOfUrgencyDescription: serviceDetail.levelOfUrgencyDescription,
      authorizationType: serviceDetail.authorizationType,
      typeOfService: serviceDetail.typeOfService,
      typeOfServiceDescription: serviceDetail.serviceTypeDescription,
      placeOfService: serviceDetail.placeOfService,
      placeOfServiceDescription: serviceDetail.placeOfServiceDescription,
      diagnosisCode: serviceDetail.diagnosisCode,
      lob: serviceDetail.lob,
      serviceRequestId: serviceDetail.serviceRequestId,
      admissionStartDate: serviceDetail.admissionStartDate,
      additionalDiagnosis: serviceDetail.additionalDiagnosis ? serviceDetail.additionalDiagnosis : [],
      modifier: '',
      medicationNameNdcCode: '',
      adjustedDrugDoseDescription: '',
      medicationFrequency: '',
      medicationQuantity: '',
      hcpcUnitsPerDose: '',
      rxDose: '',
      medicationRoute: '',
      transplantZone: '',
      transplantDonorType: '',
      transplantOrganType: '',
      requestedDays: serviceDetail.requestedDays ? serviceDetail.requestedDays : null,
      proceduresDetails: procDomainList,
      requestingProvider: {
        taxId: serviceDetail.requestingProvider.taxId ? serviceDetail.requestingProvider.taxId : '',
        cpfId: serviceDetail.requestingProvider.cpfId ? serviceDetail.requestingProvider.cpfId : '',
        npi: serviceDetail.requestingProvider.npi ? serviceDetail.requestingProvider.npi : '',
        lastName: serviceDetail.requestingProvider.lastname ? serviceDetail.requestingProvider.lastname : '',
        firstName: serviceDetail.requestingProvider.firstName ? serviceDetail.requestingProvider.firstName : '',
        groupName: serviceDetail.requestingProvider.groupName ? serviceDetail.requestingProvider.groupName : '',
        facilityName:
        serviceDetail.requestingProvider.facilityName ? serviceDetail.requestingProvider.facilityName : '',
        address: serviceDetail.requestingProvider.address ? serviceDetail.requestingProvider.address : '',
        address2: serviceDetail.requestingProvider.address2 ? serviceDetail.requestingProvider.address2 : '',
        city: serviceDetail.requestingProvider.city ? serviceDetail.requestingProvider.city : '',
        state: serviceDetail.requestingProvider.state ? serviceDetail.requestingProvider.state : '',
        zipCode: serviceDetail.requestingProvider.zipCode ? serviceDetail.requestingProvider.zipCode : '',
        phone: serviceDetail.requestingProvider.phone ? serviceDetail.requestingProvider.phone : '',
        name: serviceDetail.requestingProvider.name ? serviceDetail.requestingProvider.name : '',
      },
      cignaManaged: setCignaManaged(procDomainList),
    });
  });
  const domainObj: PriorAuthorizationDomain = {
    groupingKey: priorAuthDto.groupingKey,
    precertificationId: priorAuthDto.precertificationId,
    transactionId: priorAuthDto.transactionId,
    isAdditionalDocumentUpload: priorAuthDto.isAdditionalDocumentUpload,
    groupId: priorAuthDto.groupId,
    authorizationStatus: priorAuthDto.authorizationStatus,
    priorAuthorizationId: priorAuthDto.priorAuthorizationId,
    sourceSystemId: priorAuthDto.sourceSystemId,
    requestSubmittedDate: priorAuthDto.requestSubmittedDate,
    priorAuthorizationDomainHeader: {
      healthPlan: 'Cigna',
      partnerId: priorAuthDto.priorAuthorizationHeader.partnerId,
      partnerName: priorAuthDto.priorAuthorizationHeader.partnerName,
      userId: priorAuthDto.priorAuthorizationHeader.userId,
      servicingProvider: {
        taxId: priorAuthDto.priorAuthorizationHeader.servicingProvider.taxId,
        cpfId: priorAuthDto.priorAuthorizationHeader.servicingProvider.cpfId,
        npi: priorAuthDto.priorAuthorizationHeader.servicingProvider.npi,
        address: priorAuthDto.priorAuthorizationHeader.servicingProvider.address,
        address2: priorAuthDto.priorAuthorizationHeader.servicingProvider.address2,
        city: priorAuthDto.priorAuthorizationHeader.servicingProvider.city,
        state: priorAuthDto.priorAuthorizationHeader.servicingProvider.state,
        zipCode: priorAuthDto.priorAuthorizationHeader.servicingProvider.zipCode,
        phone: priorAuthDto.priorAuthorizationHeader.servicingProvider.phone,
        firstName: priorAuthDto.priorAuthorizationHeader.servicingProvider.firstName,
        lastName: priorAuthDto.priorAuthorizationHeader.servicingProvider.lastname,
        groupName: priorAuthDto.priorAuthorizationHeader.servicingProvider.groupName,
        facilityName: priorAuthDto.priorAuthorizationHeader.servicingProvider.facilityName,
        name: priorAuthDto.priorAuthorizationHeader.servicingProvider.name,
      },
      memberId: priorAuthDto.priorAuthorizationHeader.memberId,
      memberFirstName: priorAuthDto.priorAuthorizationHeader.memberFirstName,
      memberLastName: priorAuthDto.priorAuthorizationHeader.memberLastName,
      memberDOB: priorAuthDto.priorAuthorizationHeader.memberDOB,
      memberGroupNumber: priorAuthDto.priorAuthorizationHeader.memberGroupNumber,
    },
    priorAuthorizationDomianDetails: [],
  };
  domainObj.priorAuthorizationDomianDetails = authDetailsList;

  const domainlogObj = dataObfuscator.removeSensitiveDomainData(domainObj);

  appInsights.trackTrace({ message: `Domain Object is recorded here : ${JSON.stringify(domainlogObj)}` });

  return domainObj;
};

const DtoToDomainMapper = {
  ToDomainObject,
};

export default DtoToDomainMapper;

function setCignaManaged(procDomainList: ProcedureDetailDomain[]): boolean {
  const foundIndex = procDomainList.findIndex((proc) => proc.processedBy == 'C');
  if (foundIndex < 0) return false;
  return true;
}
